












































































































































































































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import Datepicker from 'vue2-datepicker';
import i18n from '@/services/i18n';
import i18nDb from '@/services/i18n-db';
import * as common from '../common';
import { CollapsiblePane, ComponentBase, NumberInput, Overlay, Pagination } from '../components';
import type { Comp, Dict, Utils } from '../types';


type SortField = 'ID' | 'NAME_KK' | 'NAME_RU' | 'KIND' | 'GOV_LEVEL' | 'FUNC_BLOCK' | 'POS_LEVEL' | 'REGION'
    | 'CATEGORY_LEVEL' | 'CATEGORY' | 'CATEGORY_NUMBER';

/**
 * Настройки поиска вариантов должностей госслужащих
 */
interface DictPositionSearchConfig {
    /**
     * Количество элементов на странице
     */
    itemsPerPage: number | null;

    /**
     * Индекс страницы, нумерация с `0`
     */
    page: number | null;

    /**
     * Список ID
     */
    idSet: Array<number> | null;

    /**
     * Название на казахском
     */
    nameKk: string | null;

    /**
     * Название на русском
     */
    nameRu: string | null;

    /**
     * Набор значений - Вид государственной должности
     */
    kindSet: Array<string> | null;

    /**
     * Набор значений - Уровень госуправления
     */
    govLevelSet: Array<string> | null;

    /**
     * Набор значений - Функциональный блок
     */
    funcBlockSet: Array<string> | null;

    /**
     * Стартовое значение - Уровень должности
     */
    posLevelStartValue: number | null;

    /**
     * Конечное значение - Уровень должности
     */
    posLevelEndValue: number | null;

    /**
     * Стартовое значение - Регион
     */
    regionStartValue: number | null;

    /**
     * Конечное значение - Регион
     */
    regionEndValue: number | null;

    /**
     * Стартовое значение - Уровень категории должности
     */
    categoryLevelStartValue: number | null;

    /**
     * Конечное значение - Уровень категории должности
     */
    categoryLevelEndValue: number | null;

    /**
     * Стартовое значение - Категория должности
     */
    categoryStartValue: number | null;

    /**
     * Конечное значение - Категория должности
     */
    categoryEndValue: number | null;

    /**
     * № п/п в категории
     */
    categoryNumber: string | null;

    /**
     * Поле для сортировки
     */
    sortField: SortField | null;

    /**
     * Признак "обратная сортировка" (от большего к меньшему)
     */
    reversedSort: boolean | null;
}


const translates = {
    actions: {
        get add(): string {
            return i18n.choose(
                'Добавить',
                'Қосу',
                'Add',
            );
        },
        get apply(): string {
            return i18n.choose(
                'Применить',
                'Қолдану',
                'Apply',
            );
        },
        get delete(): string {
            return i18n.choose(
                'Удалить',
                'Жою',
                'Delete',
            );
        },
        get edit(): string {
            return i18n.choose(
                'Изменить',
                'Өзгерту',
                'Edit',
            );
        },
        get refresh(): string {
            return i18n.choose(
                'Обновить',
                'Жаңарту',
                'Refresh',
            );
        },
        get save(): string {
            return i18n.choose(
                'Сохранить',
                'Сақтау',
                'Save',
            );
        },
    },
    deletionConfirmationText(id: number): string {
        return i18n.choose(
            () => `Удалить элемент с ID #${id}?`,
            () => `#${id} идентификаторы бар элементті жою керек пе?`,
            () => `Delete element with ID #${id}?`,
        )();
    },
    errors: {
        get cannotDeleteData(): string {
            return i18n.choose(
                'Не удалось удалить данные',
                'Деректерді жою мүмкін болмады',
                'Failed to delete data',
            );
        },
        get cannotLoadData(): string {
            return i18n.choose(
                'Не удалось загрузить данные',
                'Деректерді жүктеу сәтсіз аяқталды',
                'Failed to load data',
            );
        },
        get cannotSaveData(): string {
            return i18n.choose(
                'Не удалось сохранить данные',
                'Деректерді сақтау мүмкін болмады',
                'Failed to save data',
            );
        },
    },
    fields: {
        category: {
            get title(): string {
                return i18n.choose(
                    'Категория должности',
                    'Жұмыс санаты',
                    'Job category',
                );
            },
        },
        categoryLevel: {
            get title(): string {
                return i18n.choose(
                    'Уровень категории должности',
                    'Жұмыс санатының деңгейі',
                    'Job category level',
                );
            },
        },
        categoryNumber: {
            get title(): string {
                return i18n.choose(
                    '№ подпункта в категории',
                    'Санаттағы тармақшаның нөмірі',
                    'Sub-item number in the category',
                );
            },
        },
        funcBlock: {
            get title(): string {
                return i18n.choose(
                    'Функциональный блок',
                    'Функционалды блок',
                    'Functional block',
                );
            },
        },
        govLevel: {
            get title(): string {
                return i18n.choose(
                    'Уровень госуправления',
                    'Мемлекеттік басқару деңгейі',
                    'Level of government',
                );
            },
        },
        id: {
            get title(): string {
                return 'ID';
            },
        },
        kind: {
            get title(): string {
                return i18n.choose(
                    'Вид государственной должности',
                    'Мемлекеттік лауазымның түрі',
                    'Type of government position',
                );
            },
        },
        nameKk: {
            get title(): string {
                return i18n.choose(
                    'Название на казахском',
                    'Аты қазақша',
                    'Name in kazakh',
                );
            },
        },
        nameRu: {
            get title(): string {
                return i18n.choose(
                    'Название на русском',
                    'Орысша атауы',
                    'Name in russian',
                );
            },
        },
        posLevel: {
            get title(): string {
                return i18n.choose(
                    'Уровень должности',
                    'Жұмыс деңгейі',
                    'Job level',
                );
            },
        },
        region: {
            get title(): string {
                return i18n.choose(
                    'Регион',
                    'Аймақ',
                    'Region',
                );
            },
        },
    },
    filterSort: {
        get title(): string {
            return i18n.choose(
                'Фильтры, сортировка',
                'Сүзгілер, сұрыптау',
                'Filter, sort',
            );
        },
        filter: {
            get copyToMax(): string {
                return i18n.choose(
                    'Скопировать как максимальное значение',
                    'Максималды мән ретінде көшіріңіз',
                    'Copy as maximal value',
                );
            },
            get maxValue(): string {
                return i18n.choose(
                    'Максимальное значение',
                    'Максималды мән',
                    'Maximal value',
                );
            },
            get minValue(): string {
                return i18n.choose(
                    'Минимальное значение',
                    'Ең төменгі мән',
                    'Minimal value',
                );
            },
            get reset(): string {
                return i18n.choose(
                    'Сбросить фильтры',
                    'Сүзгілерді қалпына келтіру',
                    'Reset filters',
                );
            },
            get title(): string {
                return i18n.choose(
                    'Фильтры',
                    'Сүзгілер',
                    'Filters',
                );
            },
            get valueSet(): string {
                return i18n.choose(
                    'Набор значений',
                    'Мәндер жиыны',
                    'Value set',
                );
            },
            get valueSetByComma(): string {
                return i18n.choose(
                    'Набор значений, разделенных запятыми',
                    'Үтірмен бөлінген мәндер жинағы',
                    'Value set separated by commas',
                );
            },
        },
        sort: {
            get field(): string {
                return i18n.choose(
                    'Поле для сортировки',
                    'Сұрыптауға арналған өріс',
                    'Field for sorting',
                );
            },
            get reversedOrder(): string {
                return i18n.choose(
                    'Сортировать в обратном порядке',
                    'Кері ретпен сұрыптау',
                    'Sort in reverse order',
                );
            },
            get title(): string {
                return i18n.choose(
                    'Сортировка',
                    'Сұрыптау',
                    'Sort',
                );
            },
        },
    },
    messages: {
        dataDeleted(id: number): string {
            return i18n.choose(
                () => `Данные успешно удалены, ID = #${id}`,
                () => `Деректер сәтті жойылды, ID = #${id}`,
                () => `Data deleted successfully, ID = #${id}`,
            )();
        },
        dataSaved(id: number): string {
            return i18n.choose(
                () => `Данные успешно сохранены, ID = #${id}`,
                () => `Деректер сәтті сақталды, ID = #${id}`,
                () => `Data saved successfully, ID = #${id}`,
            )();
        },
    },
};

const newSearchConfig = (): DictPositionSearchConfig => {
    return {
        itemsPerPage: null,
        page: null,
        idSet: null,
        nameKk: null,
        nameRu: null,
        kindSet: null,
        govLevelSet: null,
        funcBlockSet: null,
        posLevelStartValue: null,
        posLevelEndValue: null,
        regionStartValue: null,
        regionEndValue: null,
        categoryLevelStartValue: null,
        categoryLevelEndValue: null,
        categoryStartValue: null,
        categoryEndValue: null,
        categoryNumber: null,
        sortField: null,
        reversedSort: null,
    };
};


@Component({
    components: {
        'date-picker': Datepicker,
        CollapsiblePane,
        NumberInput,
        Overlay,
        Pagination,
    },
})
export default class DictPositionListPage extends ComponentBase {
    constructor() {
        super('');
    }


    // region Lifecycle
    created() {
        // region Навигация по страницам
        this.$watch('page', () => {
            this.loadIfIdle();
        });
        this.$watch('itemsPerPage', () => {
            this.loadIfIdle();
        });
        // endregion
    }

    protected mounted() {
        this.loadIfIdle();
    }
    // endregion


    // region Util
    // noinspection JSUnusedLocalSymbols
    private translates = translates;

    private formatDate(value: Date | null): string | null {
        if (value === null) {
            return null;
        }
        return i18nDb.translateByTemplate(i18nDb.dateTemplateLong(), value);
    }

    private get fieldOptions(): Array<Comp.DropdownItemDef<SortField | null>> {
        return [
            // Не заполнено
            {
                value: null,
                text: 'Не заполнено',
            },

            // ID
            {
                value: 'ID',
                text: translates.fields.id.title,
            },

            // NAME_KK
            {
                value: 'NAME_KK',
                text: translates.fields.nameKk.title,
            },

            // NAME_RU
            {
                value: 'NAME_RU',
                text: translates.fields.nameRu.title,
            },

            // KIND
            {
                value: 'KIND',
                text: translates.fields.kind.title,
            },

            // GOV_LEVEL
            {
                value: 'GOV_LEVEL',
                text: translates.fields.govLevel.title,
            },

            // FUNC_BLOCK
            {
                value: 'FUNC_BLOCK',
                text: translates.fields.funcBlock.title,
            },

            // POS_LEVEL
            {
                value: 'POS_LEVEL',
                text: translates.fields.posLevel.title,
            },

            // REGION
            {
                value: 'REGION',
                text: translates.fields.region.title,
            },

            // CATEGORY_LEVEL
            {
                value: 'CATEGORY_LEVEL',
                text: translates.fields.categoryLevel.title,
            },

            // CATEGORY
            {
                value: 'CATEGORY',
                text: translates.fields.category.title,
            },

            // CATEGORY_NUMBER
            {
                value: 'CATEGORY_NUMBER',
                text: translates.fields.categoryNumber.title,
            },
        ];
    }

    private get kindOptions(): Array<Comp.DropdownItemDef<Dict.Position.Kind>> {
        return [
            // 'ADMINISTRATIVE' - Административная
            {
                value: 'ADMINISTRATIVE',
                text: '"ADMINISTRATIVE" - Административная',
            },

            // 'POLITICAL' - Политическая
            {
                value: 'POLITICAL',
                text: '"POLITICAL" - Политическая',
            },

            // 'DEPUTY' - Депутат
            {
                value: 'DEPUTY',
                text: '"DEPUTY" - Депутат',
            },
        ];
    }

    private get govLevelOptions(): Array<Comp.DropdownItemDef<Dict.Position.GovernmentLevel>> {
        return [
            // 'LOCAL' - местное
            {
                value: 'LOCAL',
                text: '"LOCAL" - местное',
            },

            // 'TERRITORIAL' - территориальное
            {
                value: 'TERRITORIAL',
                text: '"TERRITORIAL" - территориальное',
            },
        ];
    }

    private get govLevelNullableOptions(): Array<Comp.DropdownItemDef<Dict.Position.GovernmentLevel | null>> {
        return [
            {
                value: null,
                text: '<Пусто>',
            },

            ...this.govLevelOptions,
        ];
    }

    private get functionalBlockOptions(): Array<Comp.DropdownItemDef<Dict.Position.FunctionalBlock>> {
        return [
            // "SCS" - высший управленческий персонал
            {
                value: 'SCS',
                text: '"SCS" - высший управленческий персонал',
            },

            // "A" - основной персонал
            {
                value: 'A',
                text: '"A" - основной персонал',
            },

            // "B" - содействующий персонал
            {
                value: 'B',
                text: '"B" - содействующий персонал',
            },

            // "C" - вспомогательный персонал
            {
                value: 'C',
                text: '"C" - вспомогательный персонал',
            },
        ];
    }

    private get functionalBlockNullableOptions(): Array<Comp.DropdownItemDef<Dict.Position.FunctionalBlock | null>> {
        return [
            {
                value: null,
                text: '<Пусто>',
            },

            ...this.functionalBlockOptions,
        ];
    }
    // endregion


    // region Навигация по страницам
    private page = 0;
    private itemsPerPage = 25;
    private totalItems = 0;

    private onItemsPerPageChanged(itemsPerPage: unknown): void {
        this.itemsPerPage = (itemsPerPage as number);
    }
    // endregion


    // region Загрузка, общее
    private loading = false;
    private loadingId: symbol | null = null;
    // endregion


    // region Элементы, фильтрация, сортировка
    // noinspection JSMismatchedCollectionQueryUpdate
    private items: Array<Dict.Position_Simplified> = [];

    private filterSortModalVisible = false;
    private filterSortFilterPaneExpanded = false;
    private filterSortSortPaneExpanded = false;

    private filterIdSet: Set<number> = new Set();
    private filterIdSetInput: string = '';
    private filterNameKk: string = '';
    private filterNameKkInput: string = '';
    private filterNameRu: string = '';
    private filterNameRuInput: string = '';
    private filterKindSet: Set<Dict.Position.Kind> = new Set();
    private filterKindSetInput: Set<Dict.Position.Kind> = new Set();
    private filterGovLevelSet: Set<Dict.Position.GovernmentLevel> = new Set();
    private filterGovLevelSetInput: Set<Dict.Position.GovernmentLevel> = new Set();
    private filterFuncBlockSet: Set<Dict.Position.FunctionalBlock> = new Set();
    private filterFuncBlockSetInput: Set<Dict.Position.FunctionalBlock> = new Set();
    private filterPosLevelStartValue: number | null = null;
    private filterPosLevelStartValueInput: number | null = null;
    private filterPosLevelEndValue: number | null = null;
    private filterPosLevelEndValueInput: number | null = null;
    private filterRegionStartValue: number | null = null;
    private filterRegionStartValueInput: number | null = null;
    private filterRegionEndValue: number | null = null;
    private filterRegionEndValueInput: number | null = null;
    private filterCategoryLevelStartValue: number | null = null;
    private filterCategoryLevelStartValueInput: number | null = null;
    private filterCategoryLevelEndValue: number | null = null;
    private filterCategoryLevelEndValueInput: number | null = null;
    private filterCategoryStartValue: number | null = null;
    private filterCategoryStartValueInput: number | null = null;
    private filterCategoryEndValue: number | null = null;
    private filterCategoryEndValueInput: number | null = null;
    private filterCategoryNumber: string = '';
    private filterCategoryNumberInput: string = '';

    private sortField: SortField | null = 'ID';
    private tmpSortField: SortField | null = null;
    private reversedSort = false;
    private tmpReversedSort = false;

    private get filterIdSetParsed(): Array<number> {
        return this.filterIdSetInput
            .split(',')
            .map(value => parseInt(value.trim(), 10))
            .filter(value => (!isNaN(value)));
    }


    private changeFilterSort() {
        this.filterIdSetInput = [...this.filterIdSet].join(', ');
        this.filterNameKkInput = this.filterNameKk;
        this.filterNameRuInput = this.filterNameRu;
        this.filterKindSetInput = this.filterKindSet;
        this.filterGovLevelSetInput = this.filterGovLevelSet;
        this.filterFuncBlockSetInput = this.filterFuncBlockSet;
        this.filterPosLevelStartValueInput = this.filterPosLevelStartValue;
        this.filterPosLevelEndValueInput = this.filterPosLevelEndValue;
        this.filterRegionStartValueInput = this.filterRegionStartValue;
        this.filterRegionEndValueInput = this.filterRegionEndValue;
        this.filterCategoryLevelStartValueInput = this.filterCategoryLevelStartValue;
        this.filterCategoryLevelEndValueInput = this.filterCategoryLevelEndValue;
        this.filterCategoryStartValueInput = this.filterCategoryStartValue;
        this.filterCategoryEndValueInput = this.filterCategoryEndValue;
        this.filterCategoryNumberInput = this.filterCategoryNumber;

        this.tmpSortField = this.sortField;
        this.tmpReversedSort = this.reversedSort;
        this.filterSortModalVisible = true;
    }

    private resetFilter() {
        this.filterIdSetInput = '';
        this.filterNameKkInput = '';
        this.filterNameRuInput = '';
        this.filterKindSetInput = new Set();
        this.filterGovLevelSetInput = new Set();
        this.filterFuncBlockSetInput = new Set();
        this.filterPosLevelStartValueInput = null;
        this.filterPosLevelEndValueInput = null;
        this.filterRegionStartValueInput = null;
        this.filterRegionEndValueInput = null;
        this.filterCategoryLevelStartValueInput = null;
        this.filterCategoryLevelEndValueInput = null;
        this.filterCategoryStartValueInput = null;
        this.filterCategoryEndValueInput = null;
        this.filterCategoryNumberInput = '';
    }

    private applyFilterSort() {
        this.filterIdSet = new Set(this.filterIdSetParsed);
        this.filterNameKk = this.filterNameKkInput;
        this.filterNameRu = this.filterNameRuInput;
        this.filterKindSet = this.filterKindSetInput;
        this.filterGovLevelSet = this.filterGovLevelSetInput;
        this.filterFuncBlockSet = this.filterFuncBlockSetInput;
        this.filterPosLevelStartValue = this.filterPosLevelStartValueInput;
        this.filterPosLevelEndValue = this.filterPosLevelEndValueInput;
        this.filterRegionStartValue = this.filterRegionStartValueInput;
        this.filterRegionEndValue = this.filterRegionEndValueInput;
        this.filterCategoryLevelStartValue = this.filterCategoryLevelStartValueInput;
        this.filterCategoryLevelEndValue = this.filterCategoryLevelEndValueInput;
        this.filterCategoryStartValue = this.filterCategoryStartValueInput;
        this.filterCategoryEndValue = this.filterCategoryEndValueInput;
        this.filterCategoryNumber = this.filterCategoryNumberInput;

        this.sortField = this.tmpSortField;
        this.reversedSort = this.tmpReversedSort;
        this.loadIfIdle();
    }

    private toggleFilterKind(value: Dict.Position.Kind) {
        const set = new Set(this.filterKindSetInput);
        if (set.has(value)) {
            set.delete(value);
        } else {
            set.add(value);
        }
        this.filterKindSetInput = set;
    }

    private toggleFilterGovLevel(value: Dict.Position.GovernmentLevel) {
        const set = new Set(this.filterGovLevelSetInput);
        if (set.has(value)) {
            set.delete(value);
        } else {
            set.add(value);
        }
        this.filterGovLevelSetInput = set;
    }

    private toggleFilterFuncBlock(value: Dict.Position.FunctionalBlock) {
        const set = new Set(this.filterFuncBlockSetInput);
        if (set.has(value)) {
            set.delete(value);
        } else {
            set.add(value);
        }
        this.filterFuncBlockSetInput = set;
    }

    private loadIfIdle() {
        if (!this.loading) {
            this.load();
        }
    }

    private load() {
        if (this.loading) {
            console.error('Cannot load data - loading already in progress');
            return;
        }

        const searchConfig = newSearchConfig();
        searchConfig.itemsPerPage = this.itemsPerPage;
        searchConfig.page = this.page;
        searchConfig.sortField = this.sortField;
        searchConfig.reversedSort = this.reversedSort;

        if (this.filterIdSet.size > 0) {
            searchConfig.idSet = [...this.filterIdSet];
        }
        if (this.filterNameKk.trim().length > 0) {
            searchConfig.nameKk = this.filterNameKk.trim();
        }
        if (this.filterNameRu.trim().length > 0) {
            searchConfig.nameRu = this.filterNameRu.trim();
        }
        if (this.filterKindSet.size > 0) {
            searchConfig.kindSet = [...this.filterKindSet];
        }
        if (this.filterGovLevelSet.size > 0) {
            searchConfig.govLevelSet = [...this.filterGovLevelSet];
        }
        if (this.filterFuncBlockSet.size > 0) {
            searchConfig.funcBlockSet = [...this.filterFuncBlockSet];
        }
        if (this.filterPosLevelStartValue !== null) {
            searchConfig.posLevelStartValue = this.filterPosLevelStartValue;
        }
        if (this.filterPosLevelEndValue !== null) {
            searchConfig.posLevelEndValue = this.filterPosLevelEndValue;
        }
        if (this.filterRegionStartValue !== null) {
            searchConfig.regionStartValue = this.filterRegionStartValue;
        }
        if (this.filterRegionEndValue !== null) {
            searchConfig.regionEndValue = this.filterRegionEndValue;
        }
        if (this.filterCategoryLevelStartValue !== null) {
            searchConfig.categoryLevelStartValue = this.filterCategoryLevelStartValue;
        }
        if (this.filterCategoryLevelEndValue !== null) {
            searchConfig.categoryLevelEndValue = this.filterCategoryLevelEndValue;
        }
        if (this.filterCategoryStartValue !== null) {
            searchConfig.categoryStartValue = this.filterCategoryStartValue;
        }
        if (this.filterCategoryEndValue !== null) {
            searchConfig.categoryEndValue = this.filterCategoryEndValue;
        }
        if (this.filterCategoryNumber.trim().length > 0) {
            searchConfig.categoryNumber = this.filterCategoryNumber.trim();
        }

        const loadingId = Symbol('DictPositionListPage.load');
        this.loading = true;
        this.loadingId = loadingId;
        this.items = [];

        this.request<Utils.PaginationList<Dict.Position_Simplified>>(
            {
                url: '/api/budget/staffing_table/dict/dict_position/list',
                method: 'POST',
                data: searchConfig,
            },
            (data) => {
                if (this.loadingId !== loadingId) {
                    return;
                }

                this.totalItems = data.itemCount;
                this.page = data.page;
                this.items = data.items;
            },
            () => this.translates.errors.cannotLoadData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }

                this.loadingId = null;
                this.loading = false;
            },
        );
    }
    // endregion


    // region Редактируемый элемент
    private elementChangeModalVisible = false;

    /**
     * ID записи
     *
     * `PRIMARY KEY`
     */
    private changedElementId: number | null = null;

    /**
     * Название на казахском
     */
    private changedElementNameKk: string = '';

    /**
     * Название на русском
     */
    private changedElementNameRu: string = '';

    /**
     * Вид государственной должности:
     * * "ADMINISTRATIVE" - административная
     * * "POLITICAL" - политическая
     */
    private changedElementKind: Dict.Position.Kind = 'ADMINISTRATIVE';

    // noinspection SpellCheckingInspection
    /**
     * Уровень госуправления:
     * * "LOCAL" - местное
     * * ""TERRITORIAL"" - территориальное
     */
    private changedElementGovLevel: Dict.Position.GovernmentLevel | null = null;

    // noinspection GrazieInspection
    /**
     * Функциональный блок:
     * * "SCS" - высший управленческий персонал
     * * "A" - основной персонал
     * * "B" - содействующий персонал
     * * "C" - вспомогательный персонал
     */
    private changedElementFuncBlock: Dict.Position.FunctionalBlock | null = null;

    /**
     * Уровень должности (Обычно 1-17)
     */
    private changedElementPosLevel: number = 1;

    /**
     * Регион
     */
    private changedElementRegion: number | null = null;

    /**
     * Уровень категории должности
     */
    private changedElementCategoryLevel: number | null = null;

    /**
     * Категория должности
     */
    private changedElementCategory: number | null = null;

    /**
     * № п/п в категории
     */
    private changedElementCategoryNumber: string | null = null;

    private startElementChange(element?: Dict.Position_Simplified) {
        if (element === undefined) {
            this.changedElementId = null;
            this.changedElementNameKk = '';
            this.changedElementNameRu = '';
            this.changedElementKind = 'ADMINISTRATIVE';
            this.changedElementGovLevel = null;
            this.changedElementFuncBlock = null;
            this.changedElementPosLevel = 1;
            this.changedElementRegion = null;
            this.changedElementCategoryLevel = null;
            this.changedElementCategory = null;
            this.changedElementCategoryNumber = null;
        } else {
            this.changedElementId = element.id;
            this.changedElementNameKk = element.nameKk;
            this.changedElementNameRu = element.nameRu;
            this.changedElementKind = element.kind;
            this.changedElementGovLevel = element.govLevel;
            this.changedElementFuncBlock = element.funcBlock;
            this.changedElementPosLevel = element.posLevel;
            this.changedElementRegion = element.region;
            this.changedElementCategoryLevel = element.categoryLevel;
            this.changedElementCategory = element.category;
            this.changedElementCategoryNumber = element.categoryNumber;
        }
        this.elementChangeModalVisible = true;
    }

    private saveElement(event: unknown) {
        (event as Event).preventDefault();

        if (this.loading) {
            console.error('Cannot save data - loading already in progress');
            return;
        }

        const data: Dict.Position_Simplified = {
            id: this.changedElementId,
            nameKk: this.changedElementNameKk,
            nameRu: this.changedElementNameRu,
            kind: this.changedElementKind,
            govLevel: this.changedElementGovLevel,
            funcBlock: this.changedElementFuncBlock,
            posLevel: this.changedElementPosLevel,
            region: this.changedElementRegion,
            categoryLevel: this.changedElementCategoryLevel,
            category: this.changedElementCategory,
            categoryNumber: this.changedElementCategoryNumber,
        };


        const loadingId = Symbol('DictPositionListPage.saveElement');
        this.loading = true;
        this.loadingId = loadingId;

        this.request<number>(
            {
                url: '/api/budget/staffing_table/dict/dict_position',
                method: 'POST',
                data,
            },
            (data) => {
                this.toast(
                    'success',
                    '',
                    this.translates.messages.dataSaved(data),
                );
                this.changedElementId = data;
            },
            () => this.translates.errors.cannotSaveData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }
                this.loadingId = null;
                this.loading = false;
                this.elementChangeModalVisible = false;
                this.load();
            }
        );
    }
    // endregion


    // region Удаление элемента
    private elementDeletionModalVisible = false;
    private removedElementId: number = 0;

    private startElementDeletion(element: Dict.Position_Simplified) {
        if (element.id === null) {
            console.error('Cannot delete element - ID is NULL');
            return;
        }

        this.removedElementId = (element.id as number);
        this.elementDeletionModalVisible = true;
    }

    private deleteElement(event: unknown) {
        (event as Event).preventDefault();

        if (this.loading) {
            console.error('Cannot delete element - loading already in progress');
            return;
        }

        const id = this.removedElementId;

        const loadingId = Symbol('DictPositionListPage.saveElement');
        this.loading = true;
        this.loadingId = loadingId;

        const url = this.prepareUrl(
            '/api/budget/staffing_table/dict/dict_position',
            [
                ['id', id],
            ],
        );

        this.request<unknown>(
            {
                url,
                method: 'DELETE',
            },
            () => {
                this.toast(
                    'success',
                    '',
                    this.translates.messages.dataDeleted(id),
                );
            },
            () => this.translates.errors.cannotDeleteData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }
                this.loadingId = null;
                this.loading = false;
                this.elementDeletionModalVisible = false;
                this.load();
            }
        );
    }
    // endregion
}
